// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Profile2User, Shop, People, ShieldTick } from 'iconsax-react';

// icons — one relevant icon per destination
const icons = {
  users: Profile2User,
  stores: Shop,
  teams: People,
  roles: ShieldTick,
};

// ==============================|| MENU ITEMS - ADMINISTRATION ||============================== //
// People & places: user accounts and store directory.

const administration = {
  id: 'group-administration',
  title: <FormattedMessage id="User Management" />,
  icon: icons.users,
  type: 'group',
  children: [
    {
      id: 'users',
      title: <FormattedMessage id="Users" />,
      type: 'item',
      icon: icons.users,
      url: '/users/list',
    },
    {
      id: 'stores',
      title: <FormattedMessage id="Stores" />,
      type: 'item',
      icon: icons.stores,
      url: '/stores/list',
    },
    {
      id: 'teams',
      title: <FormattedMessage id="Teams" />,
      type: 'item',
      icon: icons.teams,
      url: '/teams/list',
    },
    {
      id: 'roles',
      title: <FormattedMessage id="Roles" />,
      type: 'item',
      icon: icons.roles,
      url: '/roles/list',
    },
  ],
};

export default administration;
